import { useEffect } from "react";

import { trpc } from "../../lib/trpc";
import { useChatPopupStore } from "../../stores/useChatPopupStore";

type MatchChatPanelProps = {
  matchId: string;
  matchStatus: string;
};

export function MatchChatPanel({ matchId, matchStatus }: MatchChatPanelProps) {
  const registerChannel = useChatPopupStore((s) => s.registerChannel);
  const removeChannel = useChatPopupStore((s) => s.removeChannel);

  const channelId = `match-${matchId}`;
  const shouldQuery = !["pending_accept", "cancelled"].includes(matchStatus);

  const { data: channels } = trpc.chat.listChannels.useQuery({ matchId }, { enabled: shouldQuery });

  const channel = channels?.[0] ?? null;

  // Auto-add match chat tab when channel is available
  useEffect(() => {
    if (!channel) return;
    registerChannel({
      id: channelId,
      type: "match",
      title: "Match Chat",
      meta: {
        channelId: channel.id,
        matchId,
        matchStatus,
      },
    });
  }, [channel, channelId, matchId, matchStatus, registerChannel]);

  // Remove match tab when match ends (completed or cancelled)
  useEffect(() => {
    if (["completed", "cancelled"].includes(matchStatus)) {
      removeChannel(channelId);
    }
  }, [matchStatus, channelId, removeChannel]);

  // Also clean up on unmount (navigating away while match is still in progress)
  useEffect(() => {
    return () => {
      removeChannel(channelId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelId]);

  return null;
}
